import React, { useEffect, useState } from "react";
import { apiAdminSubscribers } from "../lib/api";
import { Download } from "lucide-react";
import { Button } from "../components/ui/button";

const AdminSubscribers = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { apiAdminSubscribers().then((d) => { setItems(d); setLoading(false); }); }, []);

  const downloadCSV = () => {
    const csv = ["email,source,createdAt", ...items.map((i) => `${i.email},${i.source},${i.createdAt}`)].join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = "subscribers.csv"; a.click();
  };

  return (
    <div className="p-10">
      <div className="flex items-center justify-between mb-8">
        <div>
          <div className="flex items-center gap-3 mb-2"><div className="h-px w-8 bg-[#b91c1c]" /><span className="text-[10px] font-semibold tracking-[0.32em] uppercase text-[#b91c1c]">Audience</span></div>
          <h1 className="font-display text-4xl font-semibold text-[#0a0a0a] tracking-tight">Subscribers · {items.length}</h1>
        </div>
        <Button onClick={downloadCSV} className="btn-primary rounded-none h-11 px-6 text-[12px] font-semibold uppercase tracking-[0.18em]" data-testid="export-subscribers-csv-btn">
          <Download className="h-4 w-4 mr-2" /> Export CSV
        </Button>
      </div>
      {loading ? <div className="text-sm text-gray-500">Loading…</div> : (
        <div className="bg-white border border-gray-200">
          <table className="w-full text-sm">
            <thead className="bg-[#fafbfc] border-b border-gray-200 text-[10px] uppercase tracking-[0.18em] text-gray-500">
              <tr>
                <th className="text-left px-4 py-3 font-semibold">Email</th>
                <th className="text-left px-4 py-3 font-semibold">Source</th>
                <th className="text-right px-4 py-3 font-semibold">Subscribed</th>
              </tr>
            </thead>
            <tbody>
              {items.length === 0 ? (
                <tr><td colSpan={3} className="p-10 text-center text-gray-500">No subscribers yet</td></tr>
              ) : items.map((i, idx) => (
                <tr key={idx} className="border-b border-gray-100">
                  <td className="px-4 py-3 font-medium text-[#0a0a0a]">{i.email}</td>
                  <td className="px-4 py-3 text-gray-600 capitalize">{i.source}</td>
                  <td className="px-4 py-3 text-right text-gray-500 text-xs">{new Date(i.createdAt).toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AdminSubscribers;
